import React, { Component } from 'react'
import Folder from './Folder'
import { string, array, func } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { requestWidgetFolders } from '../../../utils/requests'
import { EMPTY_ARRAY } from '../../../utils/constants'
import { urlWithTrack } from '../../../helpers/common'
import AdLink from '../../ui/ad-link/AdLink'
import { widgetMessages as messages } from '../messages'

class FoldersWidget extends Component {
  constructor (props) {
    super(props)
    this.state = {
      folders: EMPTY_ARRAY
    }
    this.runFolderRequest = this.runFolderRequest.bind(this)
  }

  runFolderRequest () {
    const { items, site, handleRequestError } = this.props
    const titles = []
    items.forEach(item => {
      titles.push(item.title)
    })
    const titleString = titles.join(',')
    requestWidgetFolders(
      titleString,
      site,
      newState => {
        this.setState(newState)
      },
      () => handleRequestError()
    )
  }

  componentDidMount () {
    this.runFolderRequest()
  }

  componentDidUpdate (prevProps, prevState) {
    const { query } = this.props
    if (prevProps.query !== query) {
      this.runFolderRequest()
    }
  }

  render () {
    const { folders } = this.state
    const { query, url, items } = this.props
    const type = 'folders'
    const trackedUrl = urlWithTrack(url, type)

    return (
      <div className='widget__container'>
        {/* title */}
        <div className='widget__title'>
          <h3>
            <FormattedMessage {...messages.resultsForFolders} />
          </h3>
        </div>

        {/* more */}
        <div className='widget__anchor'>
          <AdLink href={trackedUrl}>
            <FormattedMessage {...messages.foldersSearch} />
            {` >>`}
          </AdLink>
        </div>

        {/* items slider */}
        <div className='widget-items widget-folders-items'>
          {folders.length < 1 &&
            items.slice(0, 3).map((folder, index) => (
              <div className='widget-item__wrapper' key={index}>
                <Folder widgetVersion index={index} />
              </div>
            ))}
          {folders.length > 0 &&
            folders.slice(0, 3).map((folder, index) => (
              <div className='widget-item__wrapper' key={index}>
                <Folder widgetVersion id={items[index].document_id} {...folder} index={index} query={query} />
              </div>
            ))}
        </div>
      </div>
    )
  }
}

FoldersWidget.defaultProps = {
  items: EMPTY_ARRAY,
  type: '',
  query: ''
}

FoldersWidget.propTypes = {
  items: array,
  type: string,
  query: string,
  site: string,
  handleRequestError: func,
  url: string
}

export default FoldersWidget
